















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class HelpDialog extends Vue {
  @Prop()
  private value!: boolean

  @Prop()
  private content!: ''

  private htmlContent: '' | string = ''

  private dialog = false

  @Watch('value')
  private valueChanged(newValue: boolean) {
    this.dialog = newValue
  }

  @Watch('content')
  private contentChanged(newValue: string) {
    this.htmlContent =
      '<br/><h1>Competence Match Online-Hilfe</h1><br/>' + newValue
    console.log('htmlContent: ' + this.htmlContent)
  }

  private cancel() {
    this.$emit('input')
  }

  private created() {}
}
